import { Yup, SchemaOf } from 'components/form';
import { REGEX_PATTERN, Role } from 'consts/common.const';

export interface IFormEditUser {
  pathAvatar: string;
  username: string;
  phone: string;
  email: string;
  password: string;
  confirm_password: string;
  oldPassword: string;
  level: string | number;
  send_email: string[];
  role: string | number;
  status: string | number;
  empName: string;
  ownerId: number;
}

export function getValidationSchema(roleField, t) {
  const validationSchema: SchemaOf<IFormEditUser> = Yup.object({
    pathAvatar: Yup.string(),
    username: Yup.string()
      .trim()
      .min(3, t('MS02', { field: t('user.form.username'), min: 3 }))
      .max(50, t('MS03', { field: t('user.form.username'), max: 50 }))
      .required(t('MS01', { field: t('user.form.username') })),
    empName: Yup.string()
      .trim()
      .min(3, t('MS02', { field: t('user.form.emp_name'), min: 3 }))
      .max(50, t('MS03', { field: t('user.form.emp_name'), max: 50 }))
      .required(t('MS01', { field: t('user.form.emp_name') })),
    phone: Yup.string()
      .trim()
      .required(t('MS01', { field: t('user.label.phone_number') }))
      .matches(REGEX_PATTERN.phone, t('MS27')),
    email: Yup.string()
      .email(t('MS16'))
      .required(t('MS01', { field: t('user.form.email') })),
    oldPassword: Yup.string().matches(REGEX_PATTERN.password, t('MS07')),
    password: Yup.string().when('oldPassword', {
      is: (value) => REGEX_PATTERN.password.test(value),
      then: Yup.string()
        .required(t('MS01', { field: t('page.sendmail.form.password') }))
        .matches(REGEX_PATTERN.password, t('MS07')),
      otherwise: Yup.string().matches(REGEX_PATTERN.password, t('MS07')),
    }),
    confirm_password: Yup.string().when('password', {
      is: (value) => REGEX_PATTERN.password.test(value),
      then: Yup.string()
        .required(t('MS01', { field: t('label.confirm_password_new') }))
        .oneOf([Yup.ref('password'), null], t('MS08')),
      otherwise: Yup.string().oneOf([Yup.ref('password'), null], t('MS08')),
    }),

    send_email: Yup.array(),
    role: Yup.string(),
    level:
      roleField === Role.RECER || roleField === Role.SALE
        ? Yup.string().required(t('MS01', { field: t('common.label.level') }))
        : Yup.string(),
    status: Yup.number(),
    ownerId: Yup.number().nullable(),
  });

  return validationSchema;
}

export function getInitialValues(initValues) {
  const initialValues: IFormEditUser = {
    pathAvatar: initValues.pathAvatar || '',
    username: initValues.username || '',
    phone: initValues.phone || '',
    email: initValues.email || '',
    password: '',
    confirm_password: '',
    oldPassword: '',
    send_email: ['1'],
    role: initValues.role || '',
    status: initValues.status || '',
    empName: initValues.empName || '',
    level: initValues.levelId || '',
    ownerId: initValues.ownerId || null,
  };

  return initialValues;
}
